import React, { Component, PropTypes } from 'react';

import { NitroHeading, NitroRadioGroup, NitroRadio, NitroIcon } from 'nitro-components';

import { isEmpty } from 'lodash';

class ExteriorColour extends Component {
  constructor(props) {
    super(props);
    this.state = { myColour: null };
    this.handleOptionSelect = this.handleOptionSelect.bind(this);
  }

  componentDidMount() {
    const { exteriorColour, selectedColour} = this.props;

    // console.log(exteriorColour);
    if(!isEmpty(selectedColour)) {
      this.handleOptionSelect(null, selectedColour.Value, selectedColour.Key);
      return;
    }
    if (exteriorColour.length) {
      this.handleOptionSelect(null, exteriorColour[0].Value, exteriorColour[0].Key);
    }
  }

  handleOptionSelect = (e, value, key) => {

    const { selectColour, exteriorColour } = this.props;

    this.setState({ myColour: value });
    console.log(value);
    console.log(key);
    const obj = exteriorColour.find(item => item.Value === value);
    selectColour({Value: obj.Value, Key: obj.Key});
  };

  render() {
    const { exteriorColour, selectedColour } = this.props;

    return (
      <div>
        <NitroHeading size="2" align="left" label="Colour" />
        {exteriorColour.length > 1
          ? <NitroRadioGroup defaultSelected={selectedColour ? selectedColour.Value : exteriorColour[0].Value} action={this.handleOptionSelect}>
              {exteriorColour.map((colour, index) => {
                return (
                  <NitroRadio key={index} value={colour.Value} label={colour.Value} style={{padding: '4px 0'}} />
                );
              })}
            </NitroRadioGroup>
          : <div>
              <NitroIcon name="success" variant="primary" size={16} right={12} />
              {exteriorColour[0].Value}
            </div>}
      </div>
    );
  }
}

ExteriorColour.propTypes = {
  exteriorColour: PropTypes.array.isRequired,
  selectColour: PropTypes.func.isRequired,
  selectedColour: PropTypes.object
};

export default ExteriorColour;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/components/ExteriorColour.js